module.exports = __webpack_public_path__ + "img/47_BF25_expose_yourself.f8a1e28e.jpg";